import Component from './SignUp';

export default Component;
